export const numberFormatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 });

export function compensationSuffix(type?: string) {
  if (!type) return '';
  switch (type) {
    case 'hourly': return ' / hour';
    case 'daily': return ' / day';
    case 'monthly': return ' / month';
    case 'annually': return ' / year';
    default: return '';
  }
}

function toCurrency(v: any) {
  const n = typeof v === 'number' ? v : (v ? Number(String(v).replace(/[^0-9.\-]/g, '')) : NaN);
  if (Number.isFinite(n)) return numberFormatter.format(n);
  return null;
}

export function formatCompensation(jobLike: any): string | null {
  const comp = jobLike.compensation || jobLike.salary || jobLike.compensation_formatted || jobLike.compensation_value;
  const min = jobLike.min_compensation;
  const type = jobLike.compensation_type || jobLike.compensationType || jobLike.compensation_type_formatted;

  if (!comp && !min) return null;
  if (typeof comp === 'string' && comp.toUpperCase() === 'DOE') return 'DOE';

  if (Array.isArray(comp)) {
    const parts = comp.map((c: any) => toCurrency(c)).filter(Boolean);
    if (parts.length === 0) return null;
    const buffer = parts.length === 1 ? parts[0] : `${parts[0]} - ${parts[parts.length - 1]}`;
    return `${buffer}${compensationSuffix(type)}`;
  }

  if (min && comp) {
    const a = toCurrency(min);
    const b = toCurrency(comp);
    if (a && b) return `${a} - ${b}${compensationSuffix(type)}`;
  }

  const single = toCurrency(comp || min);
  if (single) return `${single}${compensationSuffix(type)}`;

  return null;
}

export default { formatCompensation, compensationSuffix, numberFormatter };


